<template>
	<div>
		
	
	 
		
		
		<el-row :gutter="20" class="my-3">
			<el-col :span="spanRowL">
				<el-card class="box-card" shadow="">
				<div slot="header" class="clearfix">
					<h6 class="text-center mb-0">{{$t('msg.파트너')}}</h6>	
					</div>
					 <div class="hello tree-container">
					 <el-tree
					      :data="userdata"
					      v-loading="userloading"
					      node-key="mem_id"
					      class="tree"
                :expand-on-click-node="false"
					      @node-click="handleNodeClick"
					     
					      :props="defaultProps">
					               <span class="custom-tree-node" slot-scope="{ node, data }" style="display: flex;">
                              <div style="display: flex;justify-content: space-between;width: 50vw;">
                                <span>{{ node.label.mem_id }} ({{ node.label.mem_name }})</span>
                              </div>
                         </span>

					    </el-tree>
					  </div>
				</el-card>
			</el-col>
			<el-col :span="spanRowR">
				<el-card class="box-card" shadow="">
					<div slot="header" class="clearfix">
							<h6 class="text-center mb-0">
                <span v-if="this.mem_id==''">{{$t('msg.회원을선택하세요')}}</span>
                <span  v-if="this.mem_id!=''">{{mem_id}}({{mem_name}})(슬롯:{{event_loing_slot}}% 카지노:{{event_loing_e}}%)</span>
              </h6>
						
					</div>
					
				<el-tabs v-model="activeName" @tab-click="handleClick" type="border-card" class="mt-2">
      
         <el-tab-pane  name="tab1">
                         <span slot="label">{{$t('msg.카지노')}}</span>
                          <div class="d-flex" style="flex-direction:column">
                  <el-form inline ref="form" :model="idsearchform" >
                     
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:300px" >
                            </el-date-picker>
                      </el-form-item>

                      <el-form-item class="mb-0 mr-0">
                          <span class="mr-1 ml-1">하부포함</span>
                          <el-checkbox true-label="1" false-label="0" v-model="habu" class="mr-2"></el-checkbox>
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>

                  </el-form>
                 
       
    
                </div>
                  <el-table
                :data="tabList"
                border
                style="width: 100%;" v-loading="loading"
                show-summary
       :summary-method="getSummaries" class="memlistTable">
                <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt1)">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
     
      <el-table-column
        
        :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt2)">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

       <el-table-column
        
        :label="$t('msg.충환')" prop="tt12" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt12)">{{ formatMoney(scope.row.tt12)}}</span></template>
      </el-table-column>


     

      <el-table-column 
        :label="$t('msg.총배팅카')" prop="tt5ca"  align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt5ca)">{{ formatMoney(scope.row.tt5ca)}}</span></template>
      </el-table-column>
     
    
   

    
      <el-table-column
        :label="$t('msg.총당첨카')" prop="tt6ca"  align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt6ca)">{{ formatMoney(scope.row.tt6ca)}}</span></template>
      </el-table-column>
 
  

     

      <el-table-column
         :label="$t('msg.총수수료카')"  prop="tt7ca" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt7ca)">{{ formatMoney(scope.row.tt7ca)}}</span></template>
      </el-table-column>

  
     

     

      <el-table-column 
        :label="$t('msg.총수익카')" prop="tt567ca" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt567ca)">{{ formatMoney(scope.row.tt567ca)}}</span></template>
      </el-table-column>
     
     


        
  
     
    </el-table>
    
                       </el-tab-pane>
                        <el-tab-pane  name="tab2">
                         <span slot="label">{{$t('msg.슬롯')}}</span>
                          <div class="d-flex" style="flex-direction:column">
                  <el-form inline ref="form" :model="idsearchform" >
                     
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:300px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                           <span class="mr-1 ml-1">하부포함</span>
                          <el-checkbox true-label="1" false-label="0" v-model="habu" class="mr-2"></el-checkbox>
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>

                  </el-form>
                 
       
    
                </div>
                  <el-table
                :data="tabList"
                border
                style="width: 100%;" v-loading="loading"
                show-summary
       :summary-method="getSummaries" class="memlistTable">
                <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt1)">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
     
      <el-table-column
        
        :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt2)">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

       <el-table-column
        
        :label="$t('msg.충환')" prop="tt12" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt12)">{{ formatMoney(scope.row.tt12)}}</span></template>
      </el-table-column>


     

      <el-table-column 
        :label="$t('msg.총배팅슬')" prop="tt5st"  align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt5st)">{{ formatMoney(scope.row.tt5st)}}</span></template>
      </el-table-column>
     
    
   

    
      <el-table-column
        :label="$t('msg.총당첨슬')" prop="tt6st"  align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt6st)">{{ formatMoney(scope.row.tt6st)}}</span></template>
      </el-table-column>
 
  

     

      <el-table-column
         :label="$t('msg.총수수료슬')"  prop="tt7st" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt7st)">{{ formatMoney(scope.row.tt7st)}}</span></template>
      </el-table-column>

  
     

     

      <el-table-column 
        :label="$t('msg.총수익슬')" prop="tt567st" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt567st)">{{ formatMoney(scope.row.tt567st)}}</span></template>
      </el-table-column>
     
     


        
  
     
    </el-table>
   
                       </el-tab-pane>
                     </el-tabs>
					
					
				</el-card>
			</el-col>
		
		</el-row>
	
	</div>
</template>

<script>

	export default {
		 components: {
				    
				    },
		data() {
			return {
        spanRowL:4,
        spanRowR:20,
        habu:'1',
				userdata: [],
        userloading:false,
        defaultProps: {
          // 用于修改节点指定标签的属性值
          children: 'users',
          label: function(a,b){
            //console.log('label##',a,b)
            return {
              mem_id:a.mem_id,
              mem_name:a.mem_name
            }
          },
        
        },
				tabList:[],
				 idcurrentPage:1,
          idtotal:0,
          idsize:0,
				activeName:'tab1',
				tabname:'',
				tapId:'0',
        mem_id:'',
        mem_name:'',
        event_loing_slot:'',
        event_loing_e:'',
				loading:false,
				time:'',
				admin_id:window.sessionStorage.getItem('admin_id'),
				domain:window.sessionStorage.getItem('domain'),
				  ulevel:window.sessionStorage.getItem('level'),
		
				idsearchform:{
					time:[],
    				keyword:'',
    				searchOptions:[
             
			             {
			              label:this.$i18n.t("msg.전체"),
			              value:''
			            } 
		        ],
		       
		        value:'',
    			},
    			 pickerOptions: {
    			},
           shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
		
			
				
			}
		},
		
		created(){
      this.defaultDate()
      this.getUserList()
		  if(screen.width<900)
      {
             //手机
             this.spanRowL= 8
             this.spanRowR= 16
      }

			

			
		},
		mounted() {
		
		},
		methods: {
				idsearchEvent(){
                // if(this.idsearchform.keyword!='' && this.idsearchform.value == ''){
                // 	this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                // 	 return;
                // }

    			this.getTablist();

    		},
    	 func(state){
      if(state > 0){
        return "text-success"
      }else if(state <0){
         return "text-danger"
      }else if(state ===0){
         return ""
      }
    },
      handleNodeClick(data) {
        console.log('111',data); //  data 传递给 data 属性的数组中该节点所对应的对象
        this.mem_id = data.mem_id
        this.mem_name = data.mem_name
        this.event_loing_e = data.event_loing_e
        this.event_loing_slot = data.event_loing_slot
        this.tabname= this.activeName
       this.getTablist();
      },
    		
              getUserList(){
             this.userloading= true
             let token=window.sessionStorage.getItem('user');
             this.$axios({
                  method:'get',
                  url:this.domain+'/user/memtree',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     console.log('userdata=',response.data)
                     let data = response.data
                     this.userdata =data.data
                     this.userloading= false
               
            }).catch((error) =>{
               this.userloading= false
               
            })
        },
        defaultDate() {
                  var date = new Date()
                  var year = date.getFullYear().toString()
                  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
                  var da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
                  // var da = new Date(date.getFullYear(), month, 0).getDate()
                  da < 10 ? '0' + da.toString() : da.toString()
                  var beg = year + '-' + month + '-01'
                  var end = year + '-' + month + '-' + da
                  this.idsearchform.time = [beg, end] 
                },

    		getTablist(){
               let s_time="";
               let e_time="";

               // let v=this.tapId;

               let ttname=this.tabname;

               if(this.idsearchform.time.length>0)
               {
                  s_time=this.idsearchform.time[0];
                  e_time=this.idsearchform.time[1];
               }


           
             this.loading = true

             let token=window.sessionStorage.getItem('user');
             let urls='';
            
             if(ttname=="tab1")
             {
                urls=this.domain+'/user/calculation_new?mem_id='+this.mem_id+'&s_time='+s_time+'&e_time='+e_time+'&habu='+this.habu;
             }
             else if(ttname=="tab2")
             {
                urls=this.domain+'/user/calculation_new?&mem_id='+this.mem_id+'&s_time='+s_time+'&e_time='+e_time+'&habu='+this.habu;
             }
             

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     console.log('tabdata7=',response.data)
                     let data = response.data
                     this.idtotal = data.total
                     this.idcurrentPage = data.current_page
                     this.idsize =data.per_page
                     this.tabList =data.data


                     this.loading = false
                    

                   
               
            }).catch((error) =>{
               this.loading= false
               
            })
        },

         getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if(index === 0){
             sums[index] = this.$i18n.t("msg.합계");
          }
         else if (index === 1) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 2) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 3) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 4) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 5) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 6) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 7) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 8) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 9) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 10) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 11) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 12) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 13) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 14) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 15) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 16) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 17) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 18) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 19) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            } else {
              sums[index] = '/';
            }
          }
        });
        return sums;
      },
		
		 handleClick(tab, event){
         //console.log(tab.name)
          this.tabname=tab.name
              this.tapId=tab.index

             
               this.tabList=[];
                this.idcurrentPage=1
              this.getTablist();

      },
			
		},
	}
</script>

<style>


.tree .el-tree-node {
  position: relative;
  padding-left: 16px;
}
  
.tree  .el-tree-node__children {
  padding-left: 12px;
}
  
.tree  .el-tree-node :last-child:before {
  height: 50px;
}
.tree  > .el-tree-node:before {
  border: none !important;
}
.tree  .el-tree > .el-tree-node:before {
  border-left: none;
}
  
.tree-container  .el-tree > .el-tree-node:after {
  border-top: none;
}
  
.tree  .el-tree-node:before {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}
  
.tree  .el-tree-node:after {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}
.tree  .el-tree-node__expand-icon.is-leaf {
  
}
  
.tree  .el-tree-node:before {
  border-left: 1px dotted #333;
  bottom: 0px;
  height: 100%;
  top: -26px;
  width: 1px;
}
  
.tree  .el-tree-node:after {
  border-top: 1px dotted #333;
  height: 20px;
  top: 24px;
  width: 20px;
}
 
.tree  .el-tree-node__expand-icon{
 
}
.tree  .el-tree-node__content{
  padding-left: 0 !important;
}
 
.tree  .el-tree-node__content {
  height: 28px;line-height:28px;padding-top: 16px;
}
::v-deep .el-tree-node__content>.el-tree-node__expand-icon {
   
  }
 
  ::v-deep .el-tree-node__content {
    position: relative;
  }
.el-tree  .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

.el-tree  .el-icon-caret-right:before {
  background: url("../../assets/img/add.png") no-repeat 0;
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 16px;
}

.el-tree  .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
  background: url("../../assets/img/minus.png") no-repeat 0;
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 16px;
}

.el-tree  .el-tree-node__expand-icon.is-leaf::before {
  background: none;
  content: "";
  display: block;
 width:0;
 height:0;
}
.el-card__header{
	padding:8px 10px;background-color:#e5e2e2;
}

.custom-tree-node{
  align-items:center
}
.el-tree{
  color:#333
}
</style>



// WEBPACK FOOTER //
// src/views/calcuser/list.vue